













import {Component, Prop, Mixins} from 'vue-property-decorator';
import PlanEditResultMixin from '@/mixins/plan/edit/PlanEditResultMixin';
import PlanResultItem from './PlanEdtiResultItem.vue';

@Component({
    components: {
        PlanResultItem,
    },
})
export default class TabContent extends Mixins(PlanEditResultMixin) {
    @Prop() content!: any[];
    @Prop() route!: string;
    @Prop() tabData!: any;
}
